import { render, staticRenderFns } from "./somateril.vue?vue&type=template&id=199424c1&scoped=true&"
import script from "./somateril.vue?vue&type=script&lang=js&"
export * from "./somateril.vue?vue&type=script&lang=js&"
import style0 from "./somateril.vue?vue&type=style&index=0&id=199424c1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199424c1",
  null
  
)

export default component.exports